import { PrinterOptionsSchema } from "@redotech/redo-fulfillment-group-common/printer";
import * as z from "zod";

export const printPickList = {
  name: "printPickList" as const,
  input: z.intersection(
    z.union([
      z.object({ fulfillmentGroupIds: z.array(z.string()) }),
      z.object({ batchId: z.string() }),
    ]),
    z.object({
      workstationId: z.string().optional(),
      printerId: z.number().optional(),
      printerOptions: PrinterOptionsSchema.optional(),
      idempotencyKey: z.string().optional(),
    }),
  ),
  output: z.object({ url: z.string(), batchFailed: z.boolean().nullish() }),
};

export type PrintPickListInput = z.infer<typeof printPickList.input>;
